/**
 * TimePicker24h — sélecteur d'heure en format 24h, compatible tous navigateurs (Safari/iOS inclus).
 * Remplace <input type="time"> qui affiche AM/PM sur iOS selon les réglages système.
 * value : "HH:mm"  |  onChange : (value: "HH:mm") => void
 */
import { cn } from '../lib/utils';

const HOURS   = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0'));
const MINUTES = Array.from({ length: 12 }, (_, i) => String(i * 5).padStart(2, '0'));

export function TimePicker24h({ value = '18:00', onChange, className }) {
  const [hh, mm] = (value || '18:00').split(':');
  const safeHh = HOURS.includes(hh) ? hh : '18';
  // Nearest 5-min slot
  const nearestMm = MINUTES.reduce((prev, cur) =>
    Math.abs(parseInt(cur) - parseInt(mm || 0)) < Math.abs(parseInt(prev) - parseInt(mm || 0)) ? cur : prev
  );

  const handleH = (e) => onChange(`${e.target.value}:${nearestMm}`);
  const handleM = (e) => onChange(`${safeHh}:${e.target.value}`);

  const sel = cn(
    'h-10 px-2 border border-slate-200 rounded-xl text-sm font-semibold text-slate-700',
    'focus:outline-none focus:ring-2 focus:ring-[#0288D1]/20 focus:border-[#0288D1]',
    'bg-white cursor-pointer appearance-none text-center',
    className
  );

  return (
    <div className="flex items-center gap-1.5">
      <select value={safeHh} onChange={handleH} className={cn(sel, 'w-16')} aria-label="Heure">
        {HOURS.map(h => <option key={h} value={h}>{h}</option>)}
      </select>
      <span className="font-bold text-slate-500 text-lg leading-none">:</span>
      <select value={nearestMm} onChange={handleM} className={cn(sel, 'w-16')} aria-label="Minutes">
        {MINUTES.map(m => <option key={m} value={m}>{m}</option>)}
      </select>
    </div>
  );
}
